import { useAuth0 } from "@auth0/auth0-react";

export const AuthLoginPage = () => {
	const { loginWithRedirect } = useAuth0();

	const handleLogin = async () => {
		await loginWithRedirect({
			appState: {
				returnTo: "/",
			},
			authorizationParams: {
				prompt: "login",
			},
		});
	};

	return (
		<div>
			<div className="bg-1stleBackgroundImage h-screen bg-cover bg-no-repeat flex flex-col items-center justify-center space-y-10">
				<img src={process.env.REACT_APP_1STLE_LOGO_URL} alt="1ST LIGHT ENERGY" />
				<button
					className="text-gray-900 bg-gradient-to-r from-lime-200 via-lime-400 to-lime-500 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-lime-300 shadow-lg shadow-lime-500/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
					onClick={handleLogin}>
					Log In
				</button>
			</div>
		</div>
	);
};
